import React, { Component } from 'react'
import { Container, Card, FilledButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import Papa from 'papaparse'
import api from '../../utils/api'
import DownloadLink from '../DownloadLink'
import Loading from '../Loading'


class ContractedHours extends Component {
  state = {
    isErrorModalopen: false,
    result: '',
    errorText: '',
    errorList: [],
    isParsing: false,
    setMenuSelectedState: ''
  }

  componentWillMount() {
    if (this.props.setMenu === true) {
      this.props.setMenuSelectedState({ selectedMenu: '/contractedHours' })
    }
  }

  onChange = (event) => {
    if (event.target.files.length === 0) {
      return
    }

    this.setState(
      {
        result: '',
        isErrorModalopen: false,
        errorList: [],
        errorText: ''
      }
    )
    this.parseCSVFile(event)
    const target = event.target
    target.value = ''
  }

getUploadErrors = () => {
  const errors = this.state.errorList.map(error =>
    (
      <tr key={error.rowNumber} className="ln-c-table__row">
        <td className="ln-c-table__cell u-vertical-align-top">
          {error.rowNumber}
        </td>
        <td className="ln-c-table__cell u-vertical-align-top">
          {error.yCode} {this.getErrorCell(error.yCodeError)}
        </td>
        <td className="ln-c-table__cell u-vertical-align-top">
          {error.siteCode} {this.getErrorCell(error.siteCodeError)}
        </td>
        <td className="ln-c-table__cell u-vertical-align-top">
          {error.periodHours} {this.getErrorCell(error.periodHoursError)}
        </td>
        <td className="ln-c-table__cell u-vertical-align-top">
          {error.startDate} {this.getErrorCell(error.startDateError)}
        </td>
      </tr>)
  )

  return errors
}

 getErrorCell = (error) => {
   if (error) {
     return (
       <span className="ln-c-form-group has-error ln-u-flush-bottom">
         <span className="ln-c-field-info ln-c-field-info--error ln-c-field-info--validation-first">{error}</span>
       </span>
     )
   }

   return <div />
 }

  handleError = () => {
    this.setState(
      {
        isErrorModalopen: true,
        errorText: 'Failed to upload contractor hours'
      })
  }

  parseCSVFile = (event) => {
    const classThis = this
    const fileName = event.target.files[0].name
    if (fileName.substring(fileName.length - 4) !== '.csv') {
      classThis.setState(
        {
          isErrorModalopen: true,
          errorText: 'Error - invalid file type. Only a .csv file can be uploaded.'
        }
      )
      return
    }

    const fileSize = event.target.files[0].size
    const maxFileSizeKb = 100000
    if (fileSize > maxFileSizeKb) {
      classThis.setState(
        {
          isErrorModalopen: true,
          errorText: 'Error - file is too large. File size is restricted to 100KB.',
          isParsing: false
        }
      )
      return
    }
    classThis.setState(
      {
        isParsing: true
      }
    )
    Papa.parse(event.target.files[0], {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete(result) {
        classThis.parsingComplete(result)
      },
      error(error) {
        classThis.setState(
          {
            isErrorModalopen: true,
            errorText: `Error in csv - ${error}`,
            isParsing: false
          }
        )
      }
    })
  }

  parsingComplete = (result) => {
    if (result.data != null && result.data.length > 0) {
      api.uploadContractorHours(result.data)
        .then(response =>
          response.json())
        .then(response =>
          this.handleSendContractorHoursResponse(response))
        .catch(error => this.handleError(error))
    } else {
      this.setState(
        {
          errorText: 'Error in csv - no data found',
          isErrorModalopen: true,
          isParsing: false
        }
      )
    }
  }

  handleOkClick = (e) => {
    e.preventDefault()
    this.setState({ isErrorModalopen: false })
  }

  handleSendContractorHoursResponse = (response) => {
    if (response.length === 0) {
      this.setState(
        {
          result: 'Contractor Hours uploaded successfully',
          isErrorModalopen: false,
          isParsing: false
        }
      )
    } else {
      this.setState(
        {
          isErrorModalopen: true,
          errorText: 'The import was unsuccessful, correct the following errors and re-import the file.',
          errorList: response,
          isParsing: false
        })
    }

    return <div />
  }

  render() {
    return (
      <div className="ln-c-header-body ln-u-soft-top" id="main-content">
        <Container soft>
          <div className="ln-o-grid ln-u-soft-left ln-u-soft-right">
            <div className="ln-o-grid__item ln-u-1/2@sm">
              <h3 style={{ marginLeft: '30px' }}>Contracted Hours</h3>
            </div>
          </div>
          <Card className="card">
            <div className="ln-u-soft-right">
              <div className="ln-o-grid">
                <div className="ln-o-grid__item ln-u-1/1 ln-u-1/2@xs">
                  <input
                    id="myInput"
                    type="file"
                    ref={(ref) => { this.upload = ref }}
                    style={{ display: 'none' }}
                    onChange={event => this.onChange(event)}
                  />
                  <FilledButton
                    id="cmdAddEmployer"
                    className="ln-c-button ln-c-button--primary ln-u-1/1 ln-u-1/2@xs"
                    onClick={() => this.upload.click()}
                    disabled={this.state.isParsing}
                  ><span>Upload CSV</span></FilledButton>
                </div>
                <div className="ln-o-grid__item ln-u-1/1 ln-u-1/2@xs">
                  <DownloadLink
                    className="ln-c-standalone-link"
                    url={'/import/contractedhours/samplefile'}
                    fileName="ContractedHours"
                    fileExt="csv"
                  >Download template</DownloadLink>
                </div>
              </div>
            </div>
            <h4 className="ln-u-soft-top">{this.state.result}</h4>
          </Card>
          <div>
            {this.state.isParsing ? <Loading title="Processing file" /> : ''}
          </div>
          { this.state.errorText != null && this.state.errorText !== '' &&
            <div>
              <div className="ln-c-form-group has-error">
                <p className="ln-c-field-info ln-c-field-info--error ln-c-field-info--validation-first">
                  {this.state.errorText}
                </p>
              </div>
            </div>
          }
          { this.state.errorList.length > 0 &&
          <Card>
            <div className="ln-c-table-container">
              <table className="ln-c-table">
                <thead className="ln-c-table__header">
                  <tr className="ln-c-table__row ln-c-table__header-row">
                    <td className="ln-c-table__header-cell">
                      Row Number
                    </td>
                    <td className="ln-c-table__header-cell">
                      Y Code
                    </td>
                    <td className="ln-c-table__header-cell">
                      Site Code
                    </td>
                    <td className="ln-c-table__header-cell">
                      Period Hours
                    </td>
                    <td className="ln-c-table__header-cell">
                      Start Date
                    </td>
                  </tr>
                </thead>
                <tbody className="ln-c-table__body">
                  { this.getUploadErrors() }
                </tbody>
              </table>
            </div>
          </Card>
          }
        </Container>
      </div>
    )
  }
}

ContractedHours.propTypes = {
  setMenu: PropTypes.bool.isRequired,
  setMenuSelectedState: PropTypes.func.isRequired
}

export default ContractedHours




// WEBPACK FOOTER //
// ./src/components/ContractedHours/ContractedHours.jsx